import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styled from "styled-components";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";

//images
import SeveredHand from "../assets/images/severed-hand.png";
import FlyingNerdApple from "../assets/images/flying-nerd-apple-3-x@3x.png";
import Can from "../assets/images/can-3-x@3x.png";
import Apple from "../assets/images/apple-3-x@3x.png";
import FlyingApple from "../assets/images/flying-apple-3-x@3x.png";
import Cider from "../assets/images/cider-3-x@3x.png";
import Bottle from "../assets/images/bottle-3-x@3x.png";
import Glass from "../assets/images/glass-3-x@3x.png";
import LockKey from "../assets/images/lock-key-3-x@3x.png";

const ParallaxImage = styled.img`
  height: ${props => props.height || "100px"};
  width: ${props => props.width || "100px"};
  object-fit: contain;
  margin: ${props => props.margin || "0"};
  @media (max-width: 992px) {
    display: none;
  }
`;

class BackgroundLayer extends Component {
  render() {
    return (
      <ParallaxProvider>
        <Container fluid style={{ position: "absolute", top: 0, zIndex: -1 }}>
          <Row>
            <Col md={3}>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={SeveredHand}
                  alt="Severed Hand"
                  width="202px"
                  height="417px"
                  margin="
                  50px 0 0 0"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={FlyingNerdApple}
                  alt="Flying Nerd Apple"
                  width="323px"
                  height="206px"
                  margin="240px 0 0 0"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={Can}
                  alt="Can"
                  width="237px"
                  height="425px"
                  margin="156px 0 0 100px"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={Apple}
                  alt="Apple"
                  width="271px"
                  height="328px"
                  margin="175px 0 0 0"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={FlyingApple}
                  alt="Flying Apple"
                  width="284px"
                  height="413px"
                  margin="125px 0 0 0"
                />
              </Parallax>
            </Col>
            <Col />
            <Col md={3}>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={Cider}
                  alt="Cider"
                  width="281px"
                  height="433px"
                  margin="10px 0 0 0"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={Bottle}
                  alt="Bottle"
                  width="267px"
                  height="512px"
                  margin="400px 0 0 0"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={Glass}
                  alt="Glass"
                  width="254px"
                  height="411px"
                  margin="300px 0 0 0"
                />
              </Parallax>
              <Parallax y={[-10, 10]} tagOuter="figure">
                <ParallaxImage
                  src={LockKey}
                  alt="Padlock"
                  width="241px"
                  height="336px"
                  margin="150px 0 0 0"
                />
              </Parallax>
            </Col>
          </Row>
        </Container>
      </ParallaxProvider>
    );
  }
}

export default BackgroundLayer;
